<div style="width: 800px; height: 600px;" data-cy="procedure-mismatch-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="procedure-mismatch-header-section">
      <div class="section-header-title" data-cy="procedure-mismatch-title-text">
        Correct Procedure Form Mismatch
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; overflow: hidden;" data-cy="procedure-mismatch-content-section">
      <div style="flex-basis: fit-content; font-size: 18px; font-weight: 500;" data-cy="procedure-mismatch-forms-title">Forms</div>
      <div style="flex: 1; overflow-y: auto;" data-cy="procedure-mismatch-forms-list">
        <ng-container *ngFor="let form of data.Forms">
          <div style="display: flex; overflow: hidden;" data-cy="procedure-mismatch-form-item">
            <div style="font-weight: 500;" data-cy="procedure-mismatch-form-name">Procedures utlizing {{form.DFormName}}</div>
            <div style="flex: 1;"></div>
            <button (click)="swapFormForProcedures(form.DFormId)" style="margin-right: 8px;" matTooltip="You may choose another form to replace this deleted one with." class="tdo-button tdo-save" data-cy="procedure-mismatch-swap-button">Swap Procedure forms</button>
            <button (click)="deleteFormFromAllProcedures(form)" matTooltip="You this form from all the procedures utilizing it." class="tdo-button" style="background-color: var(--tdo-secondary); color: white;" data-cy="procedure-mismatch-delete-button">Delete Procedure forms</button>
          </div>
          <div style="margin-left: 8px; color: var(--tdo-primary);" *ngFor="let procedure of getProceduresForForm(form.DFormId)" data-cy="procedure-mismatch-procedure-item">
            {{procedure.ProcedureName}}
          </div>
        </ng-container>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="procedure-mismatch-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <!--<button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;">Cancel</button>-->
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="procedure-mismatch-ok-button">Ok</button>
    </div>
  </div>
</div>
